/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

/**
 * Obsahuje definici enumů používaných v Icon komponentě. Enumy jsou v separátním souboru z důvodu
 * přehlednosti.
 */

/**
 * Vlastnost `speak` ovlivňuje chování prohlížeče při čtení obsahu – používané například při
 * práci se čtečkami obrazovky.
 * @see https://css-tricks.com/almanac/properties/s/speak/
 */
export enum SpeakProperty {
    /** Komponenta dědí vlastnost ze svého předka */
    inherit = "inherit",
    /** Obsah komponenty nebude zahrnut při čtení stránky */
    none = "none",
    /** Použije se výchozí chování prohlížeče */
    normal = "normal",
}

export enum IconSize {
    large = "large",
    small = "small",
}

/**
 * Barva ikony. Na barvy se aplikuje téma aplikace.
 * Změny je nutné reflektovat v proměnné @icon-colors v souboru Icon/constants.less.
 */
export enum IconColor {

    /*----- Obecné -----*/
    default = "default",
    inherit = "inherit",

    /*----- Odstíny šedi -----*/
    /* black-white (výchozí) */
    textPrimary = "text-primary",
    textSecondary = "text-secondary",
    textDisabled = "text-disabled",
    blackWhite = "black-white",

    /* černá-černá */
    blackPrimaryFixed = "black-primary-fixed",
    blackSecondaryFixed = "black-secondary-fixed",
    blackDisabledFixed = "black-secondary-fixed",

    /* bílá-bílá */
    whitePrimaryFixed = "white-primary-fixed",
    whiteSecondaryFixed = "white-secondary-fixed",
    whiteDisabledFixed = "white-secondary-fixed",

    /* bílá-černá */
    textPrimaryInverted = "text-primary-inverted",
    textSecondaryInverted = "text-secondary-inverted",
    textDisabledInverted = "text-primary-inverted",
    whiteBlack = "white-black",

    /*----- Branding -----*/

    /* tmavá-světlá (výchozí) */
    colorPrimary = "color-primary",
    colorSecondary = "color-secondary",

    /* tmavá-tmavá */
    colorPrimaryDarkFixed = "color-primary-dark-fixed",
    colorSecondaryDarkFixed = "color-secondary-dark-fixed",
    blackFixed = "black-fixed",

    /* světlá-světlá */
    colorPrimaryLightFixed = "color-primary-light-fixed",
    colorSecondaryLightFixed = "color-secondary-light-fixed",
    whiteFixed = "white-fixed",

    /* Saturované */

    red = "red",
    pink = "pink",
    purple = "purple",
    deeppurple = "deeppurple",
    indigo = "indigo",
    blue = "blue",
    lightblue = "lightblue",
    cyan = "cyan",
    teal = "teal",
    green = "green",
    lightgreen = "light",
    lime = "lime",
    yellow = "yellow",
    amber = "amber",
    orange = "orange",
    deeporange = "deeporange",
    grey1 = "grey-1",

}
/**
 * Určuje variantu stylů tlačítka
 */
export enum IconThemeVariant {
    default = "default",
    avatar = "avatar",
}
